'use strict';

module.exports = {
    general: require('./generalMatcher'),
    msem: require('./msemMatcher')
};



// WEBPACK FOOTER //
// ../mf-matcher/src/index.js